import React, { useRef, useState } from "react";
import "./Comming_soon.css";

import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay,Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import Timer from "../timer/Timer";


const Comming_soon = () => {
  const THREE_DAYS_IN_MS = 20 * 24 * 60 * 60 * 1000;
  const NOW_IN_MS = new Date().getTime();

  const dateTimeAfterThreeDays = NOW_IN_MS + THREE_DAYS_IN_MS;

  const targetDate = new Date("2026-01-25T00:00:00").getTime();

  const imgaes = [
    "/assets/images/swiper_images/img1.webp",
    "/assets/images/swiper_images/img2.webp",
    "/assets/images/swiper_images/img3.webp",
    "/assets/images/swiper_images/img4.webp",
  ];

  return (
    <>
      <div className="container-fluid p-0">
        <section className="pin-code-comming-soon">
          <div className="row g-0">
            <div className="col-lg-4 col-md-5 order-md-1 order-2 p-0">
              <div className="sec-1">

                <div className="img_holder">
                    <img src="/assets/images/logo/logo_reverse.webp" className="logo_img"/>
                </div>

                <div className="sec-1-content">
                  <div className="main_heading">
                    <h1 className="title-2">
                      AF MOBILITÉ | une initiative de Ambassadeur Francophone{" "}
                    </h1>
                    <h1 className="title-2">
                      AF MOBILITÉ | an initiative by Ambassadeur Francophone
                    </h1>
                  </div>

                  <h3 className="title-1">
                    Nous mettons en place une plateforme pour faciliter toutes
                    vos démarches de mobilité internationale — études et stages
                    à l’étranger.
                  </h3>
                  <h3 className="title-1">
                    We are building a platform to make it easier for you to
                    manage all your study abroad and internship requests.
                  </h3>

                  <hr />

                  <p className="title-subcontent">
                    {" "}
                    Téléphone / Phone: +33 7 64 84 25 59
                  </p>
                  <p className="title-subcontent">
                    {" "}
                    E-mail / Email: contact@ambassadeurfranco.fr
                  </p>
                  <p className="title-subcontent">
                    {" "}
                    Adresse / Address : 59 Rue de Ponthieu, 75008 Paris, France{" "}
                  </p>
                </div>

              
              </div>
            </div>
            <div className="col-lg-8 col-md-7 order-md-2 order-1">
              <div className="sec-2">
                <Swiper
                  autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                  }}
                  navigation={true}
                  modules={[Autoplay, Navigation]}
                  className="loginSlider"
                >
                  {imgaes?.map((item) => {
                    return (
                      <SwiperSlide>
                        <img
                          src={process.env.PUBLIC_URL +  item }
                          alt="..."
                          className="img-fluid"
                        />
                      </SwiperSlide>
                    );
                  })}

                 

                  <div className="overlay_colour"></div>
                </Swiper>

                <div className="overlay">
                  <Timer targetDate={targetDate} />
                </div>
                 
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Comming_soon;
